import createReactComponent from '../createReactComponent';
export default createReactComponent('circle-rectangle', 'IconCircleRectangle', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M7 10h10v4h-10z', key: 'svg-1' }],
]);
